import React, { Component } from 'react';
import Loading from '../../../../image/loading.svg'

class News extends Component {
 
    render() {
        return (
            <div className="text-center m-auto">
                    <img src={Loading} alt="Loading..."/>
            </div>
        );
    }
}
export default News;